<template>
  <div class>
    <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0 text-uppercase">Approved requests</h3>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <base-table thead-classes="thead-light" :data="user.approved_bonds">
          <template slot="columns">
            <th>Date</th>
            <th>Amount</th>
            <th></th>
          </template>

          <template slot-scope="{row}">
            <td>{{row.created_at}}</td>
            <td>{{row.invested_amount | currency}}</td>
            <td>
              <span
                class="badge badge-primary pointer"
                @click="postPayment(row.uuid)"
              >Request payment</span>
            </td>
          </template>
        </base-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: Object
  },
  methods: {
    postPayment(uuid) {
      if (confirm("Confirm action?")) {
        this.saving();
        api.invest.postPayment(uuid).then(res => {
          this.saved();
          this.$emit("refresh");
        });
      }
    }
  }
};
</script>